import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetInitialStateFacade } from '../../../../../common';
import {
  ShipmentGlobalTrackingMapLoad,
  ShipmentGlobalTrackingMapSetInitialState,
} from './shipment-global-tracking-map.actions';
import { ShipmentListSearchCriteria } from '../models/shipment.model';
import { ShipmentGlobalTrackingMapModel } from '../models/shipment-list/shipment-global-tracking-map.model';
import { ShipmentGlobalTrackingMapState } from './shipment-global-tracking-map.state';
import { Observable } from 'rxjs';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { withLatestFrom } from 'rxjs/operators';
import { ShipmentListFacade } from '../list/shipment-list.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentGlobalTrackingMapFacade implements SetInitialStateFacade {
  firstChunkLoaded$: Observable<boolean> = this.store.select(ShipmentGlobalTrackingMapState.getFirstChunkLoaded);
  completelyLoaded$: Observable<boolean> = this.store.select(ShipmentGlobalTrackingMapState.getCompletelyLoaded);
  shipments$: Observable<ShipmentGlobalTrackingMapModel[]> = this.store.select(
    ShipmentGlobalTrackingMapState.getShipments,
  );
  totalShipments$: Observable<number> = this.store.select(ShipmentGlobalTrackingMapState.getTotalShipments);
  constructor(
    private store: Store,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
    private shipmentListFacade: ShipmentListFacade,
  ) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Shipment)
      .pipe(withLatestFrom(this.shipmentListFacade.mapThreshold$))
      .subscribe(([searchCriteria, mapThreshold]: [ShipmentListSearchCriteria, number]) => {
        this.store.dispatch(new ShipmentGlobalTrackingMapLoad(searchCriteria, mapThreshold));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentGlobalTrackingMapSetInitialState());
  }
}
